<template>
  <qc-container title="售后详情" show-divider show-return>
    <el-descriptions v-if="order" :column="3" border>
      <el-descriptions-item label-class-name="w100"  label="售后编号">
        {{order.code}}<span class="ml10 cp primary" @click="copyText(order.code)">复制</span>
      </el-descriptions-item>
      <el-descriptions-item label-class-name="w100"  label="申请时间">{{order.createTime}}</el-descriptions-item>
      <el-descriptions-item label-class-name="w100"  label="状态">{{order.orderStatusDesc}}</el-descriptions-item>
      <el-descriptions-item label-class-name="w100"  label="申请用户">
        <div class="flex-ac flex">
          <user-avatar :width="18" :height="18" :font-size="12" :img="order.avatarUrl" :text="order.nickname"></user-avatar>
          <span class="ml5">{{order.nickname}}</span>
        </div>
      </el-descriptions-item>
      <el-descriptions-item label-class-name="w100"  label="售后类型">{{['退款','退款退货'][order.type]}}</el-descriptions-item>
      <el-descriptions-item label-class-name="w100" v-if="order.money" label="退款金额">￥{{order.money}}</el-descriptions-item>
      <el-descriptions-item label-class-name="w100"  label="售后原因">
        <div class="flex-cc">
          <div>{{order.selectType}}{{order.reasonType}}</div>
          <image-show v-if="order.pictureList&&order.pictureList.length>0" :width="50" :height="50" :images="order.pictureList.map(item=>filePath+item.url)"></image-show>
        </div>
      </el-descriptions-item>
    </el-descriptions>
  </qc-container>
  <qc-container v-if="order && (order.expressDesc || order.refundMoney || order.refuse)" title="审核信息" class="mt20">
    <el-descriptions  :column="3" border>
      <el-descriptions-item label-class-name="w100" v-if="order.expressDesc"  label="快递公司">{{order.expressDesc}}</el-descriptions-item>
      <el-descriptions-item label-class-name="w100" v-if="order.expressCode"  label="快递单号">{{order.expressCode}}</el-descriptions-item>
      <el-descriptions-item label-class-name="w100" v-if="order.refundMoney" label="实际退款">￥{{order.refundMoney}}</el-descriptions-item>
      <el-descriptions-item label-class-name="w100" v-if="order.refuse" label="审核说明">￥{{order.refuse}}</el-descriptions-item>
    </el-descriptions>
  </qc-container>
  <qc-container v-if="order" title="订单信息" class="mt20">
    <el-descriptions  :column="3" border>
      <el-descriptions-item label-class-name="w100"  label="订单编号">
        {{order.orderOgCode}}<span class="ml10 cp primary" @click="copyText(order.orderOgCode)">复制</span>
      </el-descriptions-item>
      <el-descriptions-item label-class-name="w100" label="创建时间">{{order.createTime}}</el-descriptions-item>
      <el-descriptions-item label-class-name="w100" label="订单类型">{{['售卖','租赁','洗消'][order.goodsType]}}</el-descriptions-item>
    </el-descriptions>
    <t-table class="mt20" border :header="tableHeader" :data="order.goodsList">
      <template #before>
        <el-table-column label="商品名称" >
          <template #default="scope">
            <div class="goods-tag">
              <img class="table-img" :src="filePath+scope.row.picture">
              <div class="flex-1 ml20">
                <div class="bold">{{ scope.row.name}}</div>
                <div>ID:{{ scope.row.code}}</div>
              </div>
            </div>
          </template>
        </el-table-column>
      </template>
    </t-table>
    <div class="sumMoney">
      <div><strong>商品总金额：</strong>￥{{order.payMoney}}</div>
      <div><strong>运费：</strong>￥{{order.freight || 0}} </div>
      <div><strong>优惠：</strong>￥{{order.disCount || 0}} </div>
    </div>
    <return-box v-if="order && order.orderStatus!=7 && order.orderStatus!=1 && order.orderStatus!=6"></return-box>
  </qc-container>

  <template v-if="source==2">
    <qc-container v-if="order && (order.orderStatus==7 || order.orderStatus==1)" :title="title" class="mt20">
      <el-form class="mr20" ref="ruleForm" :model="refundRow" label-width="100px">
        <form-item-rule label="退款金额" prop="itemDesc">
          ￥{{order.money}}
        </form-item-rule>
        <form-item-rule label="审核" prop="status">
          <el-radio-group v-model="refundRow.status">
            <el-radio :label="2">同意</el-radio>
            <el-radio :label="1">拒绝</el-radio>
          </el-radio-group>
        </form-item-rule>
        <form-item-rule label="意见" prop="refundMsg">
          <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入审核意见"
            v-model="refundRow.refundMsg">
          </el-input>
        </form-item-rule>

        <div class="but-box">
          <el-button  @click="returnLast()">返回</el-button>
          <el-button type="primary" @click="doRefund()">确定</el-button>
        </div>
      </el-form>
    </qc-container>
    <qc-container v-if="order && order.orderStatus==6" title="退货退款确认" class="mt20">
      <el-form class="mr20" ref="ruleForm" :model="refundRow" label-width="100px">
        <form-item-rule label="快递公司" prop="itemDesc">
          {{order.expressDesc}}
        </form-item-rule>
        <form-item-rule label="快递单号" prop="itemDesc">
          {{order.expressCode}}
        </form-item-rule>
        <form-item-rule label="可退金额" prop="itemDesc">
          ￥{{order.money}}
        </form-item-rule>
        <form-item-rule label="退款金额" prop="itemDesc">
          <el-input-number v-model="refundGoodsRow.money" min="0.01" :precision="2" :step="0.1" :max="order.money"></el-input-number>
        </form-item-rule>

        <div class="but-box">
          <el-button  @click="returnLast()">返回</el-button>
          <el-button type="primary" @click="doGoodsConfirm()">确定</el-button>
        </div>
      </el-form>
    </qc-container>
  </template>

</template>

<script>
import QcContainer from "/src/components/el/layout/qc-container.vue";
import TTable from "@/components/el/t-table.vue";
import ReturnBox from "@/components/home/return-box.vue";
import ImageShow from "@/components/base/image-show.vue";
import UserAvatar from "@/components/base/user-avatar.vue";
import FormItemRule from "@/components/el/form-item-rule.vue";

export default {
  name: "refund-detail",
  components: {FormItemRule, UserAvatar, ImageShow, ReturnBox, TTable, QcContainer},
  data() {
    return {
      order:null,
      title:"退款审核",
      tableHeader: [
        {type: "property",label: "属性",width: 300},
        {prop: "money", label: "单价",width:100},
        {prop: "reCount", label: "数量",width:100}
      ],
      refundRow:{refundId:"",refundMsg:"",status:2},
      refundId:"",
      refundGoodsRow:{refundId:"",money:""},
      source:source
    }
  },
  mixins: [tableBase],
  methods: {
    doRefund(){
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.refundRow.refundId = this.refundId;
          this.refundRow.contentType = _CONTENT_TYPE_JSON;
          this.simplePost("/api/business/order/refund/refundCheck", this.refundRow, () => {
            this.findDetail();
          })
        }
      })
    },
    doGoodsConfirm(){
      this.simplePost("/api/business/order/refund/confirmReceipt", this.refundGoodsRow, () => {
        this.findDetail();
      })
    },
    findDetail(){
      this.simplePost("/api/business/order/refund/getRefundDetail", {refundId: this.refundId}, result => {
        this.order = result.data;

        if(this.order.type == 0){
          this.title = "退款审核";
        }else{
          this.refundGoodsRow = {refundId:this.refundId,money:this.order.money};
          this.title = "退货退款审核";
        }
      });
    }
  },
  mounted() {
    if (this.$route.query && this.$route.query.id) {
      this.refundId = this.$route.query.id;
      this.findDetail();
    }
  }
}
</script>


<style lang="less" scoped>
.goods-tag{
  display: flex;
  .flex-1 div{
    line-height: 18px;
  }
}
.table-img{
  width: 50px;
  height:50px;
}
.sumMoney{
  font-size: 12px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  div{
    line-height: 40px;
  }
}

.but-box{
  text-align: right;
}
</style>
